// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as OrderSuccessRouteImport } from './routes/order-success'
import { Route as OrderServiceRouteImport } from './routes/order-service'
import { Route as NotFoundRouteImport } from './routes/not-found'
import { Route as ContactsRouteImport } from './routes/contacts'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ServicesIndexRouteImport } from './routes/services/index'
import { Route as ServicesServiceIdRouteImport } from './routes/services/$serviceId'

const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const OrderSuccessRoute = OrderSuccessRouteImport.update({
            id: '/order-success',path: '/order-success',getParentRoute: () => rootRouteImport
          })
const OrderServiceRoute = OrderServiceRouteImport.update({
            id: '/order-service',path: '/order-service',getParentRoute: () => rootRouteImport
          })
const NotFoundRoute = NotFoundRouteImport.update({
            id: '/not-found',path: '/not-found',getParentRoute: () => rootRouteImport
          })
const ContactsRoute = ContactsRouteImport.update({
            id: '/contacts',path: '/contacts',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/services/',path: '/services/',getParentRoute: () => rootRouteImport
          })
const ServicesServiceIdRoute = ServicesServiceIdRouteImport.update({
            id: '/services/$serviceId',path: '/services/$serviceId',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,ContactsRoute: ContactsRoute,NotFoundRoute: NotFoundRoute,OrderServiceRoute: OrderServiceRoute,OrderSuccessRoute: OrderSuccessRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,ServicesServiceIdRoute: ServicesServiceIdRoute,ServicesIndexRoute: ServicesIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)